import React from 'react';

export const CuriLightbulb: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="200"
    height="200"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#curi-lightbulb-clip)">
      <path
        d="M97.4438 23.6508C69.7172 24.927 47.2192 47.4422 45.9621 75.1695C45.1496 93.0941 53.0664 109.203 65.8196 119.611C70.9309 123.782 74.0102 129.941 74.0102 136.539V149.008H125.991V136.533C125.991 130.037 128.905 123.872 133.959 119.792C146.239 109.876 154.095 94.7004 154.095 77.6871C154.095 46.9633 128.482 22.2219 97.4438 23.6508Z"
        fill="#FEE55A"
      />
      <path
        d="M80.8834 119.611C68.1303 109.203 60.2135 93.0941 61.026 75.1695C62.2073 49.1203 82.1362 27.673 107.535 24.1136C104.256 23.6566 100.883 23.4922 97.4436 23.6504C69.717 24.9265 47.219 47.4418 45.962 75.1691C45.1491 93.0937 53.0662 109.202 65.8194 119.611C70.9307 123.782 74.01 129.941 74.01 136.539V149.007H89.0745V136.539C89.0741 129.941 85.9952 123.783 80.8834 119.611Z"
        fill="#FFD301"
      />
      <path
        d="M174.714 80.6601H164.405C162.762 80.6601 161.432 79.3289 161.432 77.6871C161.432 76.0449 162.763 74.7141 164.405 74.7141H174.714C176.356 74.7141 177.687 76.0453 177.687 77.6871C177.687 79.3289 176.355 80.6601 174.714 80.6601Z"
        fill="#FEE55A"
      />
      <path
        d="M35.5957 80.6601H25.2863C23.6441 80.6601 22.3132 79.3289 22.3132 77.6871C22.3132 76.0449 23.6445 74.7141 25.2863 74.7141H35.5953C37.2375 74.7141 38.5683 76.0453 38.5683 77.6871C38.5687 79.3289 37.2375 80.6601 35.5957 80.6601Z"
        fill="#FEE55A"
      />
      <path
        d="M143.438 34.2484C142.277 33.0875 142.277 31.2047 143.438 30.0437L150.728 22.7539C151.889 21.5929 153.772 21.5929 154.933 22.7539C156.094 23.9148 156.094 25.7976 154.933 26.9586L147.643 34.2484C146.482 35.4097 144.599 35.4094 143.438 34.2484Z"
        fill="#FEE55A"
      />
      <path
        d="M45.067 132.62C43.9057 131.459 43.9057 129.577 45.067 128.415L52.3569 121.125C53.5178 119.964 55.4006 119.964 56.5616 121.125C57.7229 122.286 57.7229 124.169 56.5616 125.33L49.2717 132.62C48.1104 133.781 46.228 133.781 45.067 132.62Z"
        fill="#FEE55A"
      />
      <path
        d="M99.9999 16.2555C98.3577 16.2555 97.0269 14.9242 97.0269 13.2824V2.97305C97.0269 1.33125 98.3581 0 99.9999 0C101.642 0 102.973 1.33125 102.973 2.97305V13.282C102.973 14.9246 101.642 16.2555 99.9999 16.2555Z"
        fill="#FEE55A"
      />
      <path
        d="M52.3569 34.2485L45.067 26.9587C43.9057 25.7978 43.9057 23.9149 45.067 22.754C46.228 21.5931 48.1108 21.5931 49.2717 22.754L56.5616 30.0438C57.7229 31.2048 57.7229 33.0876 56.5616 34.2485C55.4006 35.4099 53.5182 35.4095 52.3569 34.2485Z"
        fill="#FEE55A"
      />
      <path
        d="M150.728 132.62L143.438 125.33C142.277 124.169 142.277 122.286 143.438 121.125C144.599 119.964 146.482 119.964 147.643 121.125L154.933 128.415C156.094 129.577 156.094 131.459 154.933 132.62C153.772 133.781 151.889 133.781 150.728 132.62Z"
        fill="#FEE55A"
      />
      <path
        d="M100.888 105.066C99.9901 103.692 100.377 101.849 101.751 100.951L109.086 96.1605C109.121 96.1375 109.157 96.1152 109.193 96.0937C109.932 95.6551 110.391 94.8484 110.391 93.989V80.6746C110.391 79.0324 111.722 77.7015 113.364 77.7015C115.006 77.7015 116.338 79.0328 116.338 80.6746V93.989C116.338 96.9125 114.789 99.657 112.29 101.17L105.003 105.93C103.628 106.828 101.786 106.441 100.888 105.066Z"
        fill="#FDDA5D"
      />
      <path
        d="M95.5465 105.975L87.7496 101.194C85.2277 99.6863 83.6621 96.9277 83.6621 93.9887V80.6742C83.6621 79.032 84.9934 77.7012 86.6352 77.7012C88.2773 77.7012 89.6082 79.0324 89.6082 80.6742V93.9887C89.6082 94.848 90.0672 95.6547 90.8063 96.0934C90.8184 96.1004 90.8301 96.1078 90.8418 96.1148L98.6543 100.905C100.054 101.764 100.493 103.595 99.6348 104.994C98.7766 106.395 96.9449 106.833 95.5465 105.975Z"
        fill="#FDDA5D"
      />
      <path
        d="M117.721 88.6785H82.171C80.5289 88.6785 79.198 87.3473 79.198 85.7055C79.198 84.0633 80.5292 82.7324 82.171 82.7324H117.721C119.363 82.7324 120.694 84.0637 120.694 85.7055C120.694 87.3473 119.363 88.6785 117.721 88.6785Z"
        fill="#FDDA5D"
      />
      <path
        d="M108.207 122.43C106.936 121.703 106.169 120.335 106.169 118.871V103.878C106.169 101.767 104.458 100.056 102.348 100.056H97.6523C95.5414 100.056 93.8304 101.767 93.8304 103.878V118.871C93.8304 120.335 93.0636 121.703 91.7933 122.43C89.5699 123.702 88.071 126.095 88.071 128.841V149.008H111.929V128.841C111.929 126.095 110.43 123.702 108.207 122.43Z"
        fill="#FFD301"
      />
      <path
        d="M104.199 122.43C105.32 121.788 106.047 120.646 106.203 119.38C106.182 119.212 106.169 119.042 106.169 118.871V103.877C106.169 101.766 104.458 100.055 102.348 100.055H97.6523C95.5414 100.055 93.8304 101.767 93.8304 103.877V118.871C93.8304 120.334 93.0636 121.702 91.7933 122.429C89.5699 123.702 88.071 126.095 88.071 128.841V149.007H100.477V128.841C100.477 126.095 101.975 123.702 104.199 122.43Z"
        fill="#FDDA5D"
      />
      <path
        d="M99.9999 151.981C98.3577 151.981 97.0269 150.65 97.0269 149.008V131.316C97.0269 129.673 98.3581 128.343 99.9999 128.343C101.642 128.343 102.973 129.674 102.973 131.316V149.008C102.973 150.65 101.642 151.981 99.9999 151.981Z"
        fill="#FEE55A"
      />
      <path
        d="M81.5425 184.439C83.2425 193.083 90.8585 200 99.9999 200C109.141 200 116.757 193.083 118.457 184.44L81.5425 184.439Z"
        fill="#23A8FE"
      />
      <path
        d="M96.0784 184.439H81.5425C83.2425 193.083 90.8585 200 99.9999 200C102.576 200 105.032 199.45 107.268 198.467C101.571 195.963 97.2991 190.646 96.0784 184.439Z"
        fill="#0193FA"
      />
      <path
        d="M119.802 172.1H80.1976C78.0867 172.1 76.3757 173.812 76.3757 175.922V181.014C76.3757 183.125 78.0871 184.836 80.1976 184.836H119.802C121.913 184.836 123.624 183.125 123.624 181.014V175.922C123.624 173.812 121.913 172.1 119.802 172.1Z"
        fill="#60B8FE"
      />
      <path
        d="M90.9117 181.014V175.922C90.9117 173.811 92.623 172.1 94.7335 172.1H80.1976C78.0867 172.1 76.3757 173.812 76.3757 175.922V181.014C76.3757 183.125 78.0871 184.836 80.1976 184.836H94.7335C92.6226 184.836 90.9117 183.125 90.9117 181.014Z"
        fill="#23A8FE"
      />
      <path
        d="M127.971 159.761H72.0284C69.9175 159.761 68.2065 161.473 68.2065 163.583V168.675C68.2065 170.786 69.9179 172.497 72.0284 172.497H127.971C130.082 172.497 131.793 170.786 131.793 168.675V163.583C131.793 161.472 130.082 159.761 127.971 159.761Z"
        fill="#B1DBFC"
      />
      <path
        d="M82.7425 168.675V163.583C82.7425 161.472 84.4538 159.761 86.5644 159.761H72.0284C69.9175 159.761 68.2065 161.473 68.2065 163.583V168.675C68.2065 170.786 69.9179 172.497 72.0284 172.497H86.5644C84.4534 172.497 82.7425 170.786 82.7425 168.675Z"
        fill="#8BCAFF"
      />
      <path
        d="M127.971 147.818H72.0284C69.9175 147.818 68.2065 149.53 68.2065 151.64V156.336C68.2065 158.446 69.9179 160.157 72.0284 160.157H127.971C130.082 160.157 131.793 158.446 131.793 156.336V151.64C131.793 149.53 130.082 147.818 127.971 147.818Z"
        fill="#DFEBFA"
      />
      <path
        d="M82.7425 156.336V151.641C82.7425 149.53 84.4538 147.819 86.5644 147.819H72.0284C69.9175 147.819 68.2065 149.53 68.2065 151.641V156.336C68.2065 158.447 69.9179 160.158 72.0284 160.158H86.5644C84.4534 160.158 82.7425 158.446 82.7425 156.336Z"
        fill="#B1DBFC"
      />
    </g>
    <defs>
      <clipPath id="curi-lightbulb-clip">
        <rect width="200" height="200" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CuriLightbulb;
